import { createContext, useState } from "react";

const DataLibraryContext = createContext({
  datasets: [],
  setDatasets: null,
  dataset: null,
  setDataset: null,
  metrics: [],
  setMetrics: null,
  dimensions: [],
  setDimensions: null,
});

export const DataLibraryProvider = ({ children }) => {
  const [datasets, setDatasets] = useState([]);
  const [dataset, setDataset] = useState();
  const [metrics, setMetrics] = useState([]);
  const [dimensions, setDimensions] = useState([]);

  const value = {
    datasets,
    setDatasets,
    dataset,
    setDataset,
    metrics,
    setMetrics,
    dimensions,
    setDimensions,
  };

  return (
    <DataLibraryContext.Provider value={value}>
      {children}
    </DataLibraryContext.Provider>
  );
};

export default DataLibraryContext;
